export default () => `
  <div class="content">
    Rounding to 1/2 blocks typically results in lower ballast weight.
    The installer is required to supply full size blocks (4" X 8" X 16") and 1/2 zise blocks (2" X 8" X 16").
    See Unirac's Tech Bulletin on Ballast Blocks for additional information.
  </div>
`;
